module.exports = __webpack_public_path__ + "static/media/visa-mastercard-logos.1e7ea2a8.png";